import React, { Component } from "react";
import striptags from "striptags";

class ProductDescriptionErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch() {
        this.setState({ hasError: true });

        // TODO: Get API function to log error
        // logErrorToMyService(error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="product-details__description">
                    <div>{striptags(this.props.description)}</div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ProductDescriptionErrorBoundary;
